export default __webpack_public_path__ + "793b5bd.png";